import { render, staticRenderFns } from "./CompanyForm.vue?vue&type=template&id=5cc2efaa"
import script from "./CompanyForm.vue?vue&type=script&lang=ts"
export * from "./CompanyForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports